export default [
  {
    path: '/company/:companyId/pdf-download/:billId',
    name: 'pdf-download',
    component: () => import('@/views/public/PdfDownload.vue'),
    meta: {
        layout: 'auth'
    }
  }
]